import { buildClientSchema, getIntrospectionQuery } from "graphql";
import { ofetch } from "ofetch";
import { useGraphQLMeta } from "../composables/use-graphql-meta.js";
export async function loadMeta(config) {
  const controller = new AbortController();
  setTimeout(() => controller.abort(), 5e3);
  return new Promise(async (resolve, reject) => {
    const { data: result } = await ofetch(config.public.gqlHost, {
      body: JSON.stringify({
        query: getIntrospectionQuery({ descriptions: false }),
        variables: {}
      }),
      method: "POST",
      onRequestError: (e) => {
        reject(e);
      },
      signal: controller.signal
    });
    const schema = buildClientSchema(result);
    resolve(useGraphQLMeta(schema));
  });
}
export async function hash(string) {
  const utf8 = new TextEncoder().encode(string);
  const hashBuffer = await crypto.subtle.digest("SHA-256", utf8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map((bytes) => bytes.toString(16).padStart(2, "0")).join("");
  return hashHex;
}
export async function hashPasswords(element) {
  if (!element) {
    return element;
  } else if (Array.isArray(element)) {
    return await Promise.all(element.map((item) => hashPasswords(item)));
  } else if (typeof element === "object") {
    for (const [key, value] of Object.entries(element)) {
      if (key === "password" && value && typeof value === "string") {
        element[key] = await hash(value);
      } else {
        element[key] = await hashPasswords(value);
      }
    }
  }
  return element;
}
